<template>
  <vf-button
    v-bind="{ variant, size }"
    :aria-label="$t.applePayIconText"
    :class="brandClasses?.button"
  >
    <vf-icon src="/img/logos/apple-pay.svg" v-bind="icon" />
  </vf-button>
</template>

<script lang="ts" setup>
const { brandClasses, icon, size, variant } = useAppConfig().components.checkout.applePayButton
</script>
